import { useEffect } from "react";
import { useLocalStorage } from "@uidotdev/usehooks";
import { localStorageKeys } from "../../lib/local-storage-keys";
import { useGoogleDriveSyncPolling } from "../queries/use-google-drive-settings";

export function useGoogleDriveSyncGlobal() {
    const [jobId, setJobId] = useLocalStorage<string | null>(localStorageKeys.googleDriveSyncJobId, null);
    const syncStatus = useGoogleDriveSyncPolling(jobId);

    const status = syncStatus.data?.status ?? null;
    const isSyncing = !!jobId && !!syncStatus.data && status !== "completed" && status !== "failed";
    const isComplete = !!jobId && status === "completed";
    const progress = syncStatus.data?.progress ?? null;

    // Clear jobId from localStorage once sync finishes or fails
    useEffect(() => {
        if (!jobId) return;
        if (status === "completed" || status === "failed") {
            const delay = status === "completed" ? 3000 : 1000;
            const timer = setTimeout(() => setJobId(null), delay);
            return () => clearTimeout(timer);
        }
    }, [jobId, status, setJobId]);

    return { isSyncing, progress, isComplete, status };
}
